export default __webpack_public_path__ + "locales/lo-LA/OAuth.json?hash=48284360122a24e543e4390ac624c0a1";